import { CancelablePromise } from '@acme/api/shared';
import { Icon } from '@acme/assets';
import {
  CurrencyRequest,
  currencyFormConfig,
  CurrencyResponse,
  ECurrencyTypeEnum,
} from '@acme/domains';
import {
  Form,
  FormConfig,
  FormControls,
  ResultModal,
  Separator,
  useFormModel,
  useModal,
} from '@acme/foundation';
import { Button } from 'flowbite-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface ICurrencyFormProps {
  onClose: () => void;
  defaultData?: CurrencyResponse | null;
  onSubmit: (req: { requestBody?: CurrencyRequest }) => CancelablePromise<any>;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}
export const CurrencyForm = (props: ICurrencyFormProps) => {
  const { openModal, closeModal } = useModal();
  const navigate = useNavigate();

  const formConfig = currencyFormConfig(true, [
    { label: 'Фиатная', value: '10' },
    { label: 'Цифровая', value: '20' },
  ]) as FormConfig<CurrencyRequest>;

  const form = useFormModel<CurrencyRequest>({
    config: formConfig,
    ctx: (props.defaultData || {}) as CurrencyRequest,
  });

  const handleClose = () => {
    props.onClose();
  };

  const onSubmit = async (finalModel: CurrencyRequest) => {
    try {
      const requestBody =
        finalModel.mode === 'add'
          ? {
              code: finalModel.code,
              name: finalModel.name,
            }
          : {
              type: finalModel.type,
              name: finalModel.name,
              id: props.defaultData?.id,
            };

      await props
        .onSubmit({ requestBody: requestBody as CurrencyRequest })
        .then((res) => {
          closeModal();
          openModal({
            content: (
              <ResultModal
                title={res.isSuccess ? 'Успешно' : 'Создать валюту не удалось'}
                description={
                  res.isSuccess
                    ? 'Валюта была создана'
                    : 'Попробуйте повторить позднее'
                }
                type={res.isSuccess ? 'success' : 'error'}
                onBack={() => {
                  navigate('/rates/currencyList');
                  closeModal();
                }}
              />
            ),
            opaqueBackground: true,
          });
        });
    } catch (error) {
      props.onError?.(
        error instanceof Error ? error.message : 'Ошибка при создании валюты'
      );
    }
  };
  return (
    <Form<CurrencyRequest>
      form={form}
      onSubmit={onSubmit}
      className="flex flex-col"
    >
      <div className="flex pb-5">
        <h3 className="text-gray-900 text-lg font-semibold">
          {props.defaultData ? 'Редактирование валюты' : 'Создать новую валюту'}
        </h3>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-gray-600 ml-auto"
        >
          <Icon size={10.5} name="x-outline" />
        </button>
      </div>
      <Separator className="-mx-5" />
      <div
        className="flex flex-col py-5 gap-3"
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      >
        <FormControls form={form} />
      </div>
      <Separator className="-mx-5" />
      <div className="flex gap-4 pt-5">
        <Button type="submit" color="primary" disabled={false}>
          {props.defaultData ? 'Редактировать валюту' : 'Создать валюту'}
        </Button>
        <Button color="gray" onClick={handleClose}>
          Отмена
        </Button>
      </div>
    </Form>
  );
};
